var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar"},[(_vm.showBack)?_c('a',{staticClass:"back",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$router.go(-1)}}}):_vm._e(),_c('div',{staticClass:"nav-bar-logo"})])}
var staticRenderFns = []

export { render, staticRenderFns }